<template>
  <v-data-table
    :headers="tableHeaders"
    :items="combos"
    multi-sort
    item-key="name"
    :expanded.sync="expanded"
    :single-expand="singleExpand"
    :footer-props="{ itemsPerPageOptions: [10, 20, 50] }"
    :options.sync="options"
    no-data-text="Nenhum produto adicionado ainda"
  >
    <!-- table content -->
    <template v-slot:item="{ item, expand, isExpanded, index }">
      <tr>
        <td>
          <v-img v-if="item.image" :src="item.image" width="50px" height="50px"></v-img>
          <mf-icon v-else class="ml-2" large icon="image" />
        </td>
        <td>
          <mf-tooltip top max-width="250px">
            <template v-slot:activator="{ on }">
              <span>{{ putEllipsis(item.name, 25) }}</span>
            </template>
            <span>{{ item.name }}</span>
          </mf-tooltip>
        </td>
        <td>
          <mf-tooltip top max-width="250px">
            <template v-slot:activator="{ on }">
              <span>{{ putEllipsis(item.target_products[0].name, 25) }}</span>
            </template>
            <span>{{ item.target_products[0].name }}</span>
          </mf-tooltip>
        </td>

        <td>{{ item.target_products[0].percentage_discount }}%</td>
        <td>{{ item.maximum_per_client }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { offerSalesTables } from '@/modules/campanhas/gestao-ofertas-v2/views/mixins/offer-sales-tables.js'
export default {
  name: 'ComboOfferSales',
  mixins: [offerSalesTables],
  props: {
    combos: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    expanded: [],
    singleExpand: true,
  }),
  computed: {
    tableHeaders() {
      return [
        {
          text: 'Imagem',
          value: 'image',
          width: '70px',
          sortable: false,
        },
        {
          text: 'Nome do combo',
          value: 'name',
          width: '30%',
          sortable: false,
        },
        {
          text: 'Produto com desconto',
          value: 'product',
          width: '30%',
          sortable: false,
        },
        {
          text: 'Desconto',
          value: 'discount',
          width: '100px',
          sortable: false,
        },
        {
          text: 'Máx. CPF',
          value: 'max',
          width: '100px',
          sortable: false,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
}

.expanded-itens {
  padding-left: 19%;
}

::v-deep th,
::v-deep td {
  padding: 0 8px;
}
</style>
